import {isImageRefSet} from '@packages/systems/dynamo/utils/CollectionFieldUtils';
import {createExternalKeyForCmsCollection} from '@packages/systems/dynamo/utils/BindingContextUtils';

import {defineCollectionTypeReference} from '@packages/systems/cms/gateway/shared';

import {mifBindingContextTypeId} from './identifiers';

import type {BindingContextTypeDef} from '@packages/systems/dynamo/source-types';
import type {Collections} from '@packages/systems/dynamo/records/CollectionRecord';

export default function defineBindingContextTypes(
  collections: Collections
): BindingContextTypeDef[] {
  return collections.reduce<BindingContextTypeDef[]>(
    (typeDefs, collection) => {
      if (collection._id) {
        const {entity, id} = defineCollectionTypeReference(collection);

        typeDefs.push({
          entity,
          id,
          label: collection.name,
          pluralLabel: collection.pluralName,
          singularLabel: collection.singularName,
          externalKey: createExternalKeyForCmsCollection(id),
        });

        collection.fields.forEach((field) => {
          if (isImageRefSet(field)) {
            typeDefs.push({
              entity: 'Field',
              // TODO: Do we need to incorporate collection id to ensure uniqueness?
              id: mifBindingContextTypeId(field.id),
              label: field.name,
            });
          }
        });
      }
      return typeDefs;
    },
    [rootTypeDef]
  );
}

const rootTypeDef: BindingContextTypeDef = {
  entity: 'Root',
  label: 'CMS Collections',
};
